export const baseDeeplink = "https://mobilizei.onelink.me/omcI?af_xp=qr&pid=QR_code&af_dp=mobilizei%3A%2F%2F&af_force_deeplink=true"